import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function AdminNotify() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/admin/notify").then((r) => setList(r.data)); }, []);
  return (
    <div data-testid="admin-notify-page">
      <div className="pg-micro mb-2">// Notify-Me Requests</div>
      <h1 className="text-[#F7FAFC] text-3xl pg-display mb-8" style={{ fontFamily: "'Exo 2'" }}>Stock Alert Subscribers</h1>
      <div className="pg-card divide-y divide-[#00C2D6]/10">
        {list.map((n) => (
          <div key={n.id} className="grid grid-cols-1 sm:grid-cols-3 gap-2 px-5 py-3 text-sm">
            <div className="text-[#F7FAFC] pg-mono">{n.email}</div>
            <div className="text-[#9CA8B8]">Product: {n.product_id}</div>
            <div className="text-[#9CA8B8] text-xs">{n.created_at?.slice(0, 10)}</div>
          </div>
        ))}
        {list.length === 0 && <div className="text-[#9CA8B8] text-center py-12">No notify requests yet</div>}
      </div>
    </div>
  );
}
